import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDocumentStack32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconDocumentStack32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M23 25a4 4 0 0 1-4 4h-9a4 4 0 0 1-4-4V11a4 4 0 0 1 4-4 4 4 0 0 1 4-4h5.374a2 2 0 0 1 1.411.583l5.626 5.6A2 2 0 0 1 27 10.6V21a4 4 0 0 1-4 4M12 7h3.374a2 2 0 0 1 1.411.583L18 8.792V5h-4a2 2 0 0 0-2 2m9.223 5H25v9a2 2 0 0 1-2 2v-8.4a2 2 0 0 0-.589-1.417zm3.174-2L20 5.623V10zM10 27h9a2 2 0 0 0 2-2v-9h-7V9h-4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2m6-17.377L20.397 14H16z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDocumentStack32);
